import React, { useState, useEffect } from 'react';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import { useSearchParams } from 'react-router-dom';
import Helper from 'src/helper/Helper';
import Pagination from "src/component/Global/Pagination"
import NoResultContent from '../NoResultContent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __remove, __set } from 'src/store/axios_indicator';
import Constants from 'src/helper/Constants';
import ReusableDiv from 'src/helper/ReusableDiv';
import ContentTabCommonSorting from './ContentTabCommonSorting';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';

const EventTab = () => {
    const [list, setList] = useState([]);
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [{ }, { get_home_page_content }] = useHomePageContentStore();
    const [searchParams] = useSearchParams();
    const [__check] = useAxiosIndicatorCheck();
    const [listObj, setListObj] = useState({ page: 1, pageCount: 0, limit: 20, sortBy: 'Relevance', });
    const { homePageAllTabs } = Constants;

    useEffect(() => {
        const fetchInitialData = async () => {
            await fetchAPiCall(true);
            setFirstServerCall(false);
        };
        fetchInitialData();
    }, []);

    useEffect(() => {
        if (!firstServerCall) {
            fetchAPiCall();
        }
    }, [listObj.page, listObj.limit, listObj.sortBy]);


    const fetchAPiCall = async () => {
        __set("CONTENT_API_CALL");
        const search_keyword = searchParams.get('search');
        const data = await get_home_page_content({
            pageNumber: firstServerCall ? 1 : listObj.page,
            pageSize: listObj.limit,
            orderBy: listObj.sortBy,
            searchTerm: search_keyword,
            contentType: homePageAllTabs.EVENT.contentType,
        });
        if (data[homePageAllTabs.EVENT.contentType].totalCount > 0) {
            const total = data[homePageAllTabs.EVENT.contentType].totalCount;
            setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) });
            setList(data[homePageAllTabs.EVENT.contentType].webContentView);
        } else {
            setList([]);
        }
        __remove("CONTENT_API_CALL");
    };


    const handlePageClick = (data) => {
        setListObj({ ...listObj, page: data.selected + 1 });
        Helper.scrollTop();
    };

    const setPageLimit = (event) => {
        setListObj({ ...listObj, limit: Number(event.target.value), page: 1 });
    };

    const onFilter = async (e) => {
        setListObj({ ...listObj, sortBy: e.target.value })
    }

    return (
        <div id="contentEventContent" className="tab-pane fade active in">
            <div className='event-content-wrapper'>
                <div className='bs5 row'>
                    <div className='col-lg-9 tab-data'>
                        <div className='all-content'>

                            <ContentTabCommonSorting onFilter={onFilter} headerNme={homePageAllTabs.EVENT.tabHeader} dataLength={list.length} />

                            <hr />
                            {__check(['CONTENT_API_CALL', 'ALL_CONTENT_COUNT_API_CALL']).status ? <AxiosIndicatorRunTimeLoader /> :
                                <div className='position-relative'>
                                    <div className='all-content-body'>
                                        {list.length > 0 ? list.map((v, i) => (
                                            <div className='all-content-body-item' key={i}>
                                                <div className='bs5 row m-0'>
                                                    <div className='col-lg-12'>
                                                        <div className='font-16 text-blue2 font-bold mb-1'>
                                                            <a href={v['url']} target='_blank' rel="noopener noreferrer">{v['name']}</a>
                                                        </div>
                                                        <div className='ellipses' title="">
                                                            {v['shortDescription']}
                                                        </div>
                                                        {v['shortDescription'] && v['shortDescription'].length > 140 &&
                                                            <a href={v['url']} className="text-blue2 d-block" target='_blank' rel="noopener noreferrer">Read More</a>
                                                        }
                                                        <div className="date-location-box mt-2">
                                                            <div className="date-location-item">
                                                                <b>Date:&nbsp;</b>{Helper.dateFormatFromString(v['avnDate'])} - {Helper.dateFormatFromString(v['updatedDate'])}
                                                            </div>
                                                            <br />
                                                            <div className="date-location-item">
                                                                <b>Location:&nbsp;</b>{v['avnLocation']}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        )) :
                                            firstServerCall === false && searchParams.get('search') &&
                                            <NoResultContent message={`No Events Found for <b>"${searchParams.get('search')}"</b>`} />
                                        }
                                    </div>
                                    {list.length > 0 &&
                                        <div className="pagination-row">
                                            <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div className='col-lg-3 tab-sidebar'>
                        {ReusableDiv.newsLetterAd()}
                        <div className='looking-for'>
                            <div className='looking-title font-24 font-bold font-apercu mb-2'>Looking for Products?</div>
                            <a href={void (0)} className="text-blue2 d-block">View Our New Product Introductions</a>
                            <a href={void (0)} className="text-blue2 d-block"> View Our Current Promotions</a>
                            <hr className='my-2' />
                            <div>
                                Today, we can design, make, supply and
                                deliver for customers of every size in every
                                corner of the world - whether your product
                                is still a notion on a napkin, in mass
                                production or at any point in between.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventTab;
